module.exports = __webpack_public_path__ + "static/a-full-life-b65c2a9cdc1fe693a417701d112a3476.jpg";